import railyApiService from "../raily-api.service";
import dealerAddRequestFactory from "./add/dealer-add-request.factory";
import DealerAddRequest, {
  DealerAddRequestBody,
} from "./add/dealer-add.request";
import DealerAddResponse from "./add/dealer-add.response";

const dealerApiService = () => {
  const add = (
    request: DealerAddRequest,
    abortSignal: AbortSignal,
  ): Promise<DealerAddResponse> => {
    const url = `/dealers`;

    const body: DealerAddRequestBody =
      dealerAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  return { add };
};

export default dealerApiService;
